module.exports = __webpack_public_path__ + "static/media/xiaoshoujinchengkanban.4879e5b0.png";